import { getBundleChargingModel } from './getBundleChargingModel';
import { getCreditsLimit, GetCreditsLimitParams } from './getCreditsLimit';

export interface GetFreemiumChargingModelParams extends GetCreditsLimitParams {}

export const getFreemiumChargingModel = ({
  bundleStatus,
  plans,
}: GetFreemiumChargingModelParams) =>
  getBundleChargingModel({
    bundleStatus,
    creditsLimit: getCreditsLimit({ bundleStatus, plans }),
    type: 'freemium',
  });
